// @flow

import React from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'

const CardPriceIconWrapper = styled.span`
  display: table-cell;
  padding-left: 4px;
  vertical-align: middle;
`

const CardPriceIcon = styled.i`
  margin: 0 1px;
  color: ${props => Colors.primaryColors[props.service]};
  vertical-align: middle;
  font-size: 15px;

  &[data-icon-type='flash'] {
    padding: 0 2px;
  }
  &[data-icon-size='small'] {
    font-size: 12px;
  }
  &[data-icon-size='medium'] {
    font-size: 14px;
  }
  &[data-icon-size='large'] {
    font-size: 20px;
  }
`

export default ({
  isDirectReservation,
  isTopHost,
  isLastMinutesDiscount,
  size,
  service,
}) => (
  <CardPriceIconWrapper>
    {isDirectReservation && (
      <CardPriceIcon
        className="fa fa-bolt"
        data-icon-type="flash"
        data-icon-size={size}
        service={service}
      />
    )}
    {isTopHost && (
      <CardPriceIcon
        className="icon-spm-top_host"
        data-icon-size={size}
        service={service}
      />
    )}
    {isLastMinutesDiscount && (
      <CardPriceIcon
        className="icon-spm-discount"
        data-icon-size={size}
        service={service}
      />
    )}
  </CardPriceIconWrapper>
)



// WEBPACK FOOTER //
// ./src/components/molecules/CardPriceIconWrapper/index.jsx